import { useSyncStoredVirtualBackground } from '../../../hooks/useVirtualBackground/useSyncStoredVirtualBackground';
import { VirtualBackground } from './virtualBackground';

import type { JSX } from 'react';

export const VirtualBackgroundMount = (): JSX.Element | null => {
  useSyncStoredVirtualBackground();

  return <VirtualBackground />;
};
